import { assignSealed } from "./utils/assignSealed.js";
export class Operation {
    constructor(name, type, options = {}) {
        this.name = name;
        this.type = type;
        assignSealed(this, options);
    }
}
//# sourceMappingURL=Operation.js.map